import { authzApi, workflowApi } from '@core/api';
import type { ListPipelineRunAsRequestsRequest, PipelineRunAsRequest } from '@core/types/workflow';

/** Follow server cursors so older approvals remain discoverable. */
export async function listAllRunAsRequests(filters: Omit<ListPipelineRunAsRequestsRequest, 'pagination'> = {}): Promise<PipelineRunAsRequest[]> {
  const items: PipelineRunAsRequest[] = [];
  let cursor = '';
  do {
    const result = await workflowApi.ListPipelineRunAsRequests({ ...filters, pagination: { pagination: { limit: 100, cursor, direction: 'forward' } } });
    items.push(...(result.items?.items || []));
    if (!result.pagination?.page_info?.has_next) break;
    cursor = result.pagination.page_info.next_cursor || '';
  } while (cursor);
  return items;
}

/** Show approval controls only when the viewer appears eligible.
 * The server remains authoritative and rechecks on every decision.
 */
export async function canDecideRunAsRequest(profileId: string, request: PipelineRunAsRequest): Promise<boolean> {
  const target = request.requested_actor?.entity;
  if (!profileId || !target?.id) return false;
  const type = target.type_name === 'core.userprofile' ? 'profile' : target.type_name === 'core.team' ? 'team' : target.type_name === 'core.role' ? 'role' : target.type_name;
  if (type === 'profile' && target.id === profileId) return true;
  if (type !== 'profile' && type !== 'team' && type !== 'role') return false;
  try {
    const result = await authzApi.Check({
      user: `profile:${profileId}`,
      relation: type === 'profile' ? 'owner' : type === 'team' ? 'admin' : 'assigner',
      object: `${type}:${target.id}`,
      authorization_model_id: '',
    });
    return !!result.allowed;
  } catch {
    return false;
  }
}
